module.exports = __webpack_public_path__ + "static/media/user-8.0bc6bdd9.png";